import { FooterHills, FooterWaves, FooterMountains } from "./FooterSvg";



const FOOTER_SVGS = {
  hills: FooterHills,
  waves: FooterWaves,
  mountains: FooterMountains,
} as const;

type FooterKey = keyof typeof FOOTER_SVGS;

interface FooterGraphicProps {
  variant?: FooterKey | string | null;
  className?: string;
}

const isFooterKey = (v: unknown): v is FooterKey =>
  typeof v === "string" && v in FOOTER_SVGS;

const FooterGraphic = ({ variant, className }: FooterGraphicProps) => {
  if (!variant || variant === 'none') return null;

  if (isFooterKey(variant)) {
    const SvgComponent = FOOTER_SVGS[variant];
    return <SvgComponent className={className} />;
  }

  // Otherwise treat as image URL
  return (
    <img
      src={variant}
      alt="Footer graphic"
      className={className}
    />
  );
};

export default FooterGraphic;


